import { ComponentUITypes, DefaultModelProperty, LabelValue } from '../standard'
import Season from './season-model'
import seasonProperties from './season-properties'
import { SeasonProperties } from './season-property-definitions'

export async function OnEvents(
  eventType: string,
  form: Season,
  property: SeasonProperties,
): Promise<Season> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(property: SeasonProperties): boolean {
  switch (property) {
    default:
      return false
  }
}

export function IsVisible(property: SeasonProperties): boolean {
  switch (property) {
    case SeasonProperties.Owner:
      return false
    case SeasonProperties.Id:
      return false
    case SeasonProperties.Created:
      return false
    case SeasonProperties.Updated:
      return false
    case SeasonProperties.Deleted:
      return false
    case SeasonProperties.Version:
      return false
    case SeasonProperties.Media:
      return false
    case 'mediaStatus':
      return false
    case 'seriesId':
      return false
    default:
      return true
  }
}
async function change(
  property: SeasonProperties,
  value: Season,
): Promise<Season> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<SeasonProperties>[] {
  return seasonProperties as DefaultModelProperty<SeasonProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<SeasonProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<SeasonProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<SeasonProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(property: SeasonProperties): LabelValue<any>[] {
  switch (property) {
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: SeasonProperties): boolean {
  switch (property) {
    case SeasonProperties.Media:
      return false
    case SeasonProperties.Owner:
      return false
    case SeasonProperties.Id:
      return false
    case SeasonProperties.Created:
      return false
    case SeasonProperties.Updated:
      return false
    case SeasonProperties.Deleted:
      return false
    case SeasonProperties.Version:
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<SeasonProperties>[],
): DefaultModelProperty<SeasonProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<SeasonProperties>) => {
      switch (modelProperty.name) {
        case SeasonProperties.Description:
          modelProperty.type = ComponentUITypes.TEXTAREA
          break
        default:
          break
      }
      return modelProperty
    },
  )
}
